// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2ewXv","rootSmall":"AddTileButton_rootSmall__nmt1F"};